<template>
  <server-log-table kind="importLog" />
</template>

<script>
import ServerLogTable from '../LogPages/ServerLogTable.vue'

export default {
  components: { ServerLogTable },
}
</script>
